/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addReaction} from '../api'

export const useMutationAddReaction = createReactQueryMutationHook('addReaction', addReaction)
